import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Page from 'src/components/Page';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Grid, Container } from '@material-ui/core';
import SiriusLogo from 'src/assets/images/konsep_2.jpg';
import axios from 'src/utils/axios';

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(0),
    paddingBottom: theme.spacing(0)
  },
  media: {
    height: 0,
    paddingTop: '56.25%' // 16:9
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    transform: 'rotate(180deg)'
  },
  avatar: {
    backgroundColor: '#1D3343'
  },
  active: {
    fontWeight: '500',
    color:
      theme.palette.type === 'light'
        ? theme.palette.background.dark
        : theme.palette.text.secondary,
    textAlign: 'center'
  }
}));

export default function ProductRelease() {
  const classes = useStyles();
  const { t } = useTranslation('common');
  const [ProductReleasebyAppIdList, setProductReleasebyAppIdList] = useState([]);
  
  const [expanded, setExpanded] = useState(Array(ProductReleasebyAppIdList.length).fill(false));

  useEffect(() => {
    GetProductReleaseList(4);
  }, []);
  const GetProductReleaseList = (Id) => {
    axios.get(`/GetProductReleaseByAppId/${Id}`)
      .then((response) => {
        if (response.data.length > 0) {
          setProductReleasebyAppIdList(response.data);
        }
      })
      .catch((error) => {
  
      });
  };

  



  const handleExpandClick = (index) => {
    // Create a copy of the expanded array
    const updatedExpanded = [...expanded];
    // Toggle the expansion state for the specific item at the given index
    updatedExpanded[index] = !updatedExpanded[index];
    // Update the expanded state
    setExpanded(updatedExpanded);
  };
  
  return (
    <>
      <Page title="">
        <Container maxWidth="xl" className={classes.root}>
          <Grid container spacing={1}>
             {ProductReleasebyAppIdList && ProductReleasebyAppIdList?.map((item,index) => (
            <Grid item xs={12} sm={6} lg={6} key={index}>
              <Card>
                <CardHeader
                  avatar={
                    <Avatar aria-label="recipe" className={classes.avatar}>
                      T
                    </Avatar>
                  }
                  title={t('lblPRDate')}
                  subheader={new Date(item.ReleaseDate).toLocaleDateString('en-GB')}
                />
                <CardMedia className={classes.media} image={item.FileData==''?SiriusLogo:`data:image/png;base64,${item.FileData}`}  />
                <CardContent>
                  <Typography className={classes.active}>
                  {t(item.Title)}
                  </Typography>
                </CardContent>
                <CardActions disableSpacing>
                  <IconButton
                    className={clsx(classes.expand, {
                      [classes.expandOpen]: expanded[index]
                    })}
                    onClick={() => handleExpandClick(index)}
                    aria-expanded={expanded[index]}
                    aria-label="show more"
                  >
                    <ExpandMoreIcon />
                  </IconButton>
                </CardActions>
                <Collapse in={expanded[index]}  timeout="auto" unmountOnExit>
                  <CardContent>
                    <Typography paragraph>
                    <li>{t(item.Desc)}</li>
                    </Typography>

                  </CardContent>
                </Collapse>
              </Card>
            </Grid>
  ))}
          </Grid>
        </Container>
      </Page>
    </>
  );
}
